


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import { SurveyGroupingElement } from '@/models/survey-elements/grouping-element';
import WidgetWrapper from '@/components/WidgetWrapper.vue';
import { SurveyElementsUnion } from '@/models/survey-elements-union';

@Component({
  name: 'grouping-element',
  components: {
    WidgetWrapper,
    ValidationObserver,
    FieldValidationError: () => import('@/components/FieldValidationError.vue'),
  },
})
export default class GroupingElementWidget extends Vue {
  $refs!: Vue['$refs'] & {
    observer: InstanceType<typeof ValidationObserver>;
  };
  @Prop({ type: Object }) field?: SurveyGroupingElement;
  @Prop({ type: Boolean, default: true }) outlined!: boolean;

  private get fieldElements() {
    return this.field?.elements.sort((a, b) => a.order - b.order);
  }
}
